export const areContentIdsEqual = (a, b) => {
    // Ensure inputs are sorted arrays
    if (!Array.isArray(a)) a = [a];
    if (!Array.isArray(b)) b = [b];
    a.sort();
    b.sort();

    // Compare arrays for equality
    return a.length === b.length && a.every((value, index) => value === b[index]);
}

export const areContentIdsConflicting  = (a, b) => {
    // Ensure inputs are arrays
    if (!Array.isArray(a)) a = [a];
    if (!Array.isArray(b)) b = [b];

    // Convert inputs to Sets
    a = new Set(a);
    b = new Set(b);
    let intersection = new Set(
        [...a].filter(x => b.has(x)));

    // Ensure sets do not intersect
    return intersection.size !== 0;
}


